import React, { useContext } from 'react'
import { Button, Modal } from 'reactstrap'
import check from '../../assets/images/check.png'
import loginagain from '../../assets/images/login-again.png'
import { MessageHandlerContext } from '../../context/MessageHandlerContextProvider'
import PropTypes from 'prop-types'
import { AppContext } from '../../context/AppContextProvider'
import { ModalContext } from '../../context/ModalContextProvider'
import { SalesType } from '../../util/constants'
import { useLocation } from 'react-router-dom'

const PurchaseComplete = (props) => {
  const { purchasedState } = useContext(MessageHandlerContext)
  const { salesType, site } = useContext(AppContext)
  const { setMobileNumberModal, setOtpModal, setNicModal } = useContext(ModalContext)

  const location = useLocation()

  const handleLoginAgain = () => {
    localStorage.removeItem('authToken')
    sessionStorage.removeItem('authToken')

    props.toggle()
    setOtpModal(false)
    setNicModal(false)
    setTimeout(() => {
      setMobileNumberModal(true)
    }, 300)
  }

  const processComplete = () => {
    if (location.pathname.includes('lotto-collection')) {
      props.toggle()
      return
    }

    if (!site || !site.includes('https://playstreet.games')) {
      window.open(process.env.REACT_APP_CLIENT_PROXY_TRACKING_URL, '_blank')
    } else {
      window.location.reload()
    }
  }

  /*eslint-disable*/
  return (
    <Modal isOpen={props.opened} toggle={props.toggle} backdrop="static">
      <div className="login_otp">
        <div className="login_otp_wrapper text-center">
          <img src={purchasedState ? check : loginagain} alt="status" /><br />

          {purchasedState ? (
            <>
              <h6>
                {salesType === SalesType.SUBSCRIPTION
                  ? 'Subscription Successful.'
                  : 'Purchase Successful.'}
              </h6>
              <Button color="warning" block onClick={processComplete}>
                {site && site.includes('https://playstreet.games')
                  ? 'Play More'
                  : 'More Lotteries'}
              </Button>
            </>
          ) : (
            <>
              <h6>Your session has expired. Please login again to continue.</h6>
              <Button color="warning" block onClick={handleLoginAgain}>
                Login Again
              </Button>
            </>
          )}
        </div>
      </div>
    </Modal>
  )
}

PurchaseComplete.propTypes = {
  opened: PropTypes.bool,
  toggle: PropTypes.func,
  iscollection: PropTypes.bool
}

export default PurchaseComplete
